import { VOICE_RECORDING_ERROR } from "@arbolus-technologies/models/common";

const MIME_TYPE_TO_EXTENSION: Record<string, string> = {
  "audio/webm": "webm",
  "audio/ogg": "ogg",
  "audio/mp4": "m4a"
};

const DEFAULT_AUDIO_EXTENSION = "webm";

const SECONDS_PER_MINUTE = 60;

export const DEFAULT_MAX_RECORDING_DURATION_SECONDS = 5 * SECONDS_PER_MINUTE;

export const VOICE_INPUT_ERROR_TRANSLATION_KEY: Record<
  VOICE_RECORDING_ERROR,
  string
> = {
  [VOICE_RECORDING_ERROR.PERMISSION_DENIED]: "voiceInputPermissionDenied",
  [VOICE_RECORDING_ERROR.UNSUPPORTED_MIME_TYPE]: "voiceInputUnsupported",
  [VOICE_RECORDING_ERROR.NO_MICROPHONE]: "voiceInputNoMicrophone",
  [VOICE_RECORDING_ERROR.MICROPHONE_IN_USE]: "voiceInputMicrophoneInUse",
  [VOICE_RECORDING_ERROR.INSECURE_CONTEXT]: "voiceInputInsecureContext",
  [VOICE_RECORDING_ERROR.RECORDING_FAILED]: "voiceInputRecordingFailed"
};

export const getFileNameFromBlob = (blob: Blob): string => {
  const baseType = blob.type.split(";")[0];
  const extension = MIME_TYPE_TO_EXTENSION[baseType] ?? DEFAULT_AUDIO_EXTENSION;
  return `recording.${extension}`;
};

export const formatRecordingTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / SECONDS_PER_MINUTE);
  const remainingSeconds = seconds % SECONDS_PER_MINUTE;
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
};
